import { useRef, useEffect } from "react";

const HERO_PHOTO = "https://customer-assets.emergentagent.com/job_tulsi-home/artifacts/vf1765f5_Tulsi.jpeg";

export function HeroSection({ scrollTo }) {
  const heroTextRef = useRef(null);
  const heroPhotoRef = useRef(null);

  useEffect(() => {
    requestAnimationFrame(() => {
      heroTextRef.current?.classList.add("visible");
      heroPhotoRef.current?.classList.add("visible");
    });
  }, []);

  return (
    <section id="top" className="hm-section py-16 md:py-24" style={{ background: "var(--white)" }} data-testid="hero-section">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center gap-12 md:gap-16">
        <div ref={heroTextRef} className="w-full md:w-[55%] order-2 md:order-1 slide-left">
          <p className="hm-mono" style={{ fontSize: "0.65rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.18em", color: "var(--ink3)", marginBottom: 12 }} data-testid="hero-eyebrow">Nepal &middot; Switzerland &middot; Global</p>
          <p style={{ color: "var(--ink3)", fontSize: 14, marginBottom: 8 }} data-testid="hero-greeting">Namaste! — My name is Tulsi Giri</p>
          <h1 data-testid="hero-headline">
            <span className="hm-display block" style={{ fontSize: "clamp(2rem, 5vw, 2.8rem)", fontWeight: 700, lineHeight: 1.15, color: "var(--ink)" }}>I believe in systems.</span>
            <span className="hm-display block" style={{ fontSize: "clamp(2rem, 5vw, 2.8rem)", fontWeight: 700, fontStyle: "italic", lineHeight: 1.15, color: "var(--green)" }}>A dreamer who gets things built.</span>
          </h1>
          <p style={{ color: "var(--ink2)", lineHeight: 1.75, marginTop: 20 }} data-testid="hero-tagline-1">I am an entrepreneur for two decades establishing food systems initiatives that connect farmers to markets, villages to cities, consumers to good food, actions to policies, and Nepal to The World.</p>
          <p style={{ color: "var(--ink2)", lineHeight: 1.75, marginTop: 12 }} data-testid="hero-tagline-2">I've always believed that building relationships create magic — it's a commons we share.</p>
          <div className="flex flex-wrap gap-3 mt-8" data-testid="hero-buttons">
            <button onClick={() => scrollTo("work")} className="hm-btn-filled">Explore my work</button>
            <button onClick={() => scrollTo("contact")} className="hm-btn-ghost">Let's connect</button>
          </div>
          <div className="flex flex-wrap gap-2 mt-6" data-testid="hero-tags">
            <span className="hm-tag" style={{ background: "var(--green-l)", color: "var(--green)" }}>Food Systems</span>
            <span className="hm-tag" style={{ background: "var(--coral-l)", color: "var(--coral)" }}>Entrepreneurship</span>
            <span className="hm-tag" style={{ background: "var(--blue-l)", color: "var(--blue)" }}>Sustainable Impacts</span>
            <span className="hm-tag" style={{ background: "var(--amber-l)", color: "var(--amber)" }}>Nepal &middot; Switzerland &middot; Global</span>
          </div>
        </div>
        <div ref={heroPhotoRef} className="w-full md:w-[45%] order-1 md:order-2 slide-right" data-testid="hero-photo">
          <img src={HERO_PHOTO} alt="Tulsi Giri" className="hm-portrait" />
        </div>
      </div>
    </section>
  );
}
